export default __webpack_public_path__ + "static/media/cpp.67546ee3.svg";